import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { AppContainer } from 'react-hot-loader'
import { setupIonicReact, isPlatform } from '@ionic/react'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import '@ionic/react/css/core.css'
// Inter hébergée avec l'appli (08/10) : plus d'appel à Google Fonts, qui
// transmettait l'adresse IP des joueurs. Latin seul, les graisses utilisées.
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-700.css'
import '@fontsource/inter/latin-800.css'
import './index.scss'
import store from './store'
import { history } from './store/middlewares/router'
import AppRouting from './app/AppRouting'
import * as serviceWorker from './serviceWorker'
import { BaseProvider } from './context/BaseContext'
import setupLocatorUI from '@locator/runtime'
import { msalConfig } from './authConfig'
import { installChunkReload } from './utils/chunkReload'

// Un déploiement pendant qu'un onglet est ouvert : les fichiers de l'ancienne
// version manquent, on recharge une fois plutôt que de rester sur un écran blanc.
installChunkReload()

const azureEnabled = !!process.env.REACT_APP_AZURE_CLIENT_ID

let msalInstance: PublicClientApplication | null = null

if (azureEnabled) {
    msalInstance = new PublicClientApplication(msalConfig)

    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
    }

    msalInstance.addEventCallback((event) => {
        if (
            (event.eventType === EventType.LOGIN_SUCCESS ||
             event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
             event.eventType === EventType.SSO_SILENT_SUCCESS) &&
            event.payload.account
        ) {
            msalInstance!.setActiveAccount(event.payload.account)
        }
    })
}

const debug = false
const getConfig = () => {
    if (isPlatform('hybrid')) {
        return {
            swipeBackEnabled: false,
            hardwareBackButton: false
        }
    }
    if (debug) {
        setupLocatorUI()
    }
    return {
        swipeBackEnabled: false
    }
}
setupIonicReact(getConfig())

const app = (
    <AppContainer>
        <Provider store={store}>
            <BaseProvider>
                <ConnectedRouter history={history}>
                    <AppRouting />
                </ConnectedRouter>
            </BaseProvider>
        </Provider>
    </AppContainer>
)

ReactDOM.render(
    azureEnabled && msalInstance
        ? <MsalProvider instance={msalInstance}>{app}</MsalProvider>
        : app,
    document.getElementById('root')
)

if (module.hot) {
    module.hot.accept()
}

serviceWorker.unregister()
